var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/IndexComponents/Illustrations/Illustrations.jinja"] = require( "front/components/IndexComponents/Illustrations/Illustrations.jinja" );
dependencies["front/components/IndexComponents/Animations/Animations.jinja"] = require( "front/components/IndexComponents/Animations/Animations.jinja" );
dependencies["front/components/IndexComponents/Storyboards/Storyboards.jinja"] = require( "front/components/IndexComponents/Storyboards/Storyboards.jinja" );




var shim = require("/var/www/django/bangbangstudio.ru/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/IndexComponents/Content/Content.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/IndexComponents/Content/Content.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/components/IndexComponents/Illustrations/Illustrations.jinja", false, "assets/app/front/components/IndexComponents/Content/Content.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "IndexIllustrations")) {
var t_7 = t_4.IndexIllustrations;
} else {
cb(new Error("cannot import 'IndexIllustrations'")); return;
}
context.setVariable("IndexIllustrations", t_7);
output += "\n";
env.getTemplate("front/components/IndexComponents/Animations/Animations.jinja", false, "assets/app/front/components/IndexComponents/Content/Content.jinja", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(Object.prototype.hasOwnProperty.call(t_8, "IndexAnimations")) {
var t_11 = t_8.IndexAnimations;
} else {
cb(new Error("cannot import 'IndexAnimations'")); return;
}
context.setVariable("IndexAnimations", t_11);
output += "\n";
env.getTemplate("front/components/IndexComponents/Storyboards/Storyboards.jinja", false, "assets/app/front/components/IndexComponents/Content/Content.jinja", false, function(t_13,t_12) {
if(t_13) { cb(t_13); return; }
t_12.getExported(function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
if(Object.prototype.hasOwnProperty.call(t_12, "IndexStoryboards")) {
var t_15 = t_12.IndexStoryboards;
} else {
cb(new Error("cannot import 'IndexStoryboards'")); return;
}
context.setVariable("IndexStoryboards", t_15);
output += "\n\n";
var macro_t_16 = runtime.makeMacro(
[], 
["illustrations", "animations", "storyboards", "intro", "lang"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("illustrations", Object.prototype.hasOwnProperty.call(kwargs, "illustrations") ? kwargs["illustrations"] : []);frame.set("animations", Object.prototype.hasOwnProperty.call(kwargs, "animations") ? kwargs["animations"] : []);frame.set("storyboards", Object.prototype.hasOwnProperty.call(kwargs, "storyboards") ? kwargs["storyboards"] : {});frame.set("intro", Object.prototype.hasOwnProperty.call(kwargs, "intro") ? kwargs["intro"] : {});frame.set("lang", Object.prototype.hasOwnProperty.call(kwargs, "lang") ? kwargs["lang"] : "");var t_17 = "";t_17 += "\n    <div class=\"IndexContent\">\n        <div class=\"IndexContent-left\">\n            <a href=\"#illustrations\" class=\"IndexContent-leftItem active\">";
t_17 += runtime.suppressValue((lineno = 8, colno = 78, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Иллюстрация"])), env.opts.autoescape);
t_17 += "</a>\n            <a href=\"#animations\" class=\"IndexContent-leftItem\">";
t_17 += runtime.suppressValue((lineno = 9, colno = 68, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Анимация"])), env.opts.autoescape);
t_17 += "</a>\n            <a href=\"#storyboards\" class=\"IndexContent-leftItem\">";
t_17 += runtime.suppressValue((lineno = 10, colno = 69, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Сториборды"])), env.opts.autoescape);
t_17 += "</a>\n        </div>\n        <div class=\"IndexContent-right\">\n            ";
t_17 += runtime.suppressValue((lineno = 13, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "IndexIllustrations"), "IndexIllustrations", context, [runtime.contextOrFrameLookup(context, frame, "illustrations")])), env.opts.autoescape);
t_17 += "\n            ";
t_17 += runtime.suppressValue((lineno = 14, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "IndexAnimations"), "IndexAnimations", context, [runtime.contextOrFrameLookup(context, frame, "animations")])), env.opts.autoescape);
t_17 += "\n            ";
t_17 += runtime.suppressValue((lineno = 15, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "IndexStoryboards"), "IndexStoryboards", context, [runtime.contextOrFrameLookup(context, frame, "storyboards")])), env.opts.autoescape);
t_17 += "\n        </div>\n    </div>\n    <div class=\"IndexInfo\">\n        ";
if(runtime.contextOrFrameLookup(context, frame, "intro") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "intro")),"info")) {
t_17 += "\n            <div class=\"isHide info\" data-scroll data-scroll-offset=\"60\">\n                ";
t_17 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "intro")),"info")), env.opts.autoescape);
t_17 += "\n            </div>\n        ";
;
}
else {
t_17 += "\n            <div class=\"info\">\n                ";
if(runtime.contextOrFrameLookup(context, frame, "lang") == "ru") {
t_17 += "\n                    <p class=\"isHide\" data-scroll data-scroll-offset=\"60\">Мы делаем иллюстрации&nbsp;для крупнейших компаний\n                        и&nbsp;брендов — вы можете их увидеть в приложении&nbsp;\n                        <a href=\"/illustrations/search/?query=sberbank\">«СберБанк Онлайн»</a> <span>◑◑</span>,\n                        в статьях про главные тренды моды и культуры на\n                        <a href=\"/illustrations/search/?query=the-blueprint\">The Blueprint</a> <span>◑◑</span>, в залах\n                        <a href=\"/illustrations/search/?query=mosfilm\">«Мосфильма»</a> <span>◑◑</span>,\n                        парке <a href=\"/illustrations/search/?query=zaryad-e\">«Зарядье»</a> <span>◑◑</span>, открытках к\n                        170-летию\n                        <a href=\"/illustrations/search/?query=red-october\">«Красного Октября»</a> <span>◑◑</span>, раскрасках\n                        для <a href=\"/illustrations/search/?query=danilovsky-market\">Даниловского рынка</a> <span>◑◑</span>,\n                        промо для <a href=\"/illustrations/search/?query=audi\">Audi</a> <span>◑◑</span> и даже под землей — в\n                        московском <a href=\"/illustrations/search/?query=mosgortrans\">Метрополитене</a> <span>◑◑</span>!</p>\n                ";
;
}
else {
t_17 += "\n                    <p class=\"isHide\" data-scroll data-scroll-offset=\"60\">We create artwork for the biggest brands out there.\n                        You can see our illustrations\n                        in the <a href=\"/en/illustrations/search/?query=sberbank\">'Sberbank Online'</a> <span>◑◑</span> app,\n                        in <a href=\"/en/illustrations/search/?query=the-blueprint\">'The Blueprint'</a> <span>◑◑</span> magazine\n                        articles on the latest culture and fashion trends, in the galleries of\n                        the <a href=\"/en/illustrations/search/?query=mosfilm\">'Mosfilm' Studio</a> <span>◑◑</span>,\n                        in the <a href=\"/en/illustrations/search/?query=zaryad-e\">'Zaryadie'</a> <span>◑◑</span> park,\n                        on postcards marking the 170th year anniversary of\n                        <a href=\"/en/illustrations/search/?query=red-october\">'Krasniy Orktabr'</a> <span>◑◑</span>,\n                        in coloring books at\n                        <a href=\"/en/illustrations/search/?query=danilovsky-market\">'Danilovskiy Market'</a> <span>◑◑</span>,\n                        in an <a href=\"/en/illustrations/search/?query=audi\">Audi</a> <span>◑◑</span> promo and even underground\n                        in the <a href=\"/en/illustrations/search/?query=mosgortrans\">Moscow subway</a> <span>◑◑</span>!</p>\n                ";
;
}
t_17 += "\n            </div>\n        ";
;
}
t_17 += "\n        <div class=\"IndexInfo-link isHide\" data-scroll data-scroll-offset=\"60\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "lang") == "ru") {
t_17 += "\n                <a href=\"/illustrations/clients/\">Здесь</a> все наши клиенты. Хотите к ним?\n            ";
;
}
else {
t_17 += "\n                Want to join our amazing list of clients?\n                <a href=\"/en/illustrations/clients/\">This is where they are!</a>\n            ";
;
}
t_17 += "\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_17);
});
context.addExport("Content");
context.setVariable("Content", macro_t_16);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/IndexComponents/Content/Content.jinja"] , dependencies)